module.exports = __webpack_public_path__ + "fonts/Roboto-500-cyrillic-ext8.62ced72.woff2";